import FHIR from "fhirclient";
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Layout } from '../Layout';
import { getSettings, getQueryStringParameter } from '../../utils';

export const LaunchPractitioner = () => {
	const redirectUri = getQueryStringParameter(useLocation().search, 'redirecturi');

	useEffect(() => {
		getSettings().then((settings) => {
			FHIR.oauth2.authorize({
				clientId: settings.fhirClientId,
				scope: settings.practitionerLauncherScope,
				iss: settings.practitionerLauncherEndpoint,
				redirectUri: redirectUri
			});
		});
	}, [redirectUri]);

	return (
		<Layout />
	);
}

export const LaunchPatient = () => {
	const redirectUri = getQueryStringParameter(useLocation().search, 'redirecturi');

	useEffect(() => {
		getSettings().then((settings) => {
			FHIR.oauth2.init({
				clientId: settings.fhirClientId,
				scope: settings.patientLauncherScope,
				iss: settings.patientLauncherEndpoint,
				redirectUri: redirectUri
			});
		});
	}, [redirectUri]);

	return (
		<Layout />
	);
}
